export default __webpack_public_path__ + "static/media/phone1Mob.1129880e.svg";